<template>
    <div class="w-100 pt-5" @click="hideSearchHistory()">
        <div class="container-fluid">
            <form action="#" @submit.prevent="submitSearch()" autocomplete="off" @click.stop>

                <div class="position-relative">
                    <div class="spinner" :class="{ 'active' : loading, 'distance' : filters.text !== '' }"></div>
                    <div class="clear-text" :class="{ 'active' : filters.text !== '' }" @click="clearText()"></div>
                    <input type="search" class="form-control search-field" name="q" id="searchField" :aria-label="search_placeholder" :placeholder="search_placeholder" enterkeyhint="search" inputmode="search" v-model="filters.text" @focus="showSearchHistory()" @blur="hideSearchHistory()">
                    <button class="d-none">Sök</button>
                </div>

                <div :class="{ 'd-none' : !showProductAreaFilter }" v-if="app_version === 'customer_card'">
<!--                    <div class="btn btn-filter me-2 mt-2"-->
<!--                         :class="{ 'active' : filters.product_area === null }"-->
<!--                         @click="setProductArea(null)"-->
<!--                    >-->
<!--                        Alla tjänster-->
<!--                    </div>-->
                    <div class="btn btn-filter me-2 mt-2"
                         :class="{ 'active' : filters.product_area === product_area}"
                         :key="'product_area'+product_area"
                         @click="setProductArea(product_area)"
                         v-for="product_area in productAreas"
                    >
                        {{ productAreaName(product_area) }}
                    </div>
                </div>

                <div :class="{ 'd-none' : !showDurationFilter }">
                    <div class="btn btn-filter me-2 mt-2"
                         :class="{ 'active' : filters.duration === null }"
                         @click="setDuration(null)"
                    >
                        Alla längder
                    </div>
                    <div class="btn btn-filter me-2 mt-2"
                         :class="{ 'active' : filters.duration === duration}"
                         :key="'duration'+duration"
                         @click="setDuration(duration)"
                         v-for="duration in durations"
                    >
                        {{ duration }} min
                    </div>
                </div>

            </form>

        </div>

        <transition name="fade">
            <div class="search-history-container" @click="hideSearchHistory()" v-if="searchHistoryVisible && searchHistory.length" :class="{ 'has-filters' : showDurationFilter }">

                <div class="container-fluid">
                    <div class="search-history" @click.stop>
                        <div class="search-history-row" :key="'history'+index" v-for="(search, index) in searchHistory" @click="searchFromHistory(search)">
                            <img src="/images/card/search-history.svg"> {{ search }}
                        </div>
                        <div class="search-history-row clear" @click="clearSearchHistory()" v-if="searchHistory.length">
                            <img src="/images/card/search-history-clear.svg"> Rensa sökhistorik
                        </div>
                    </div>
                </div>

            </div>
        </transition>

    </div>

</template>

<script>
import Cookies from 'js-cookie'

export default {

    props: {
        showDurationFilter: {
            required: true
        },
        showProductAreaFilter: {
            required: true
        },
        durations: {
            required: true
        },
        productAreas: {
            required: true
        },
        preselectedProductArea: {
            required: true
        },
        loading: {
            required: true
        }
    },

    data () {
        return {
            filters: {
                text: '',
                duration: null,
                product_area: null
            },
            searchHistoryVisible: false,
            searchHistory: []
        }
    },

    mounted () {
        this.setProductArea(this.preselectedProductArea)
    },

    computed: {
        search_placeholder () {
            if (this.preselectedProductArea === 2) {
                return 'Sök tränare, ort, anläggning...'
            }
            return 'Sök mottagning, massör, ort...'
        }
    },

    methods: {
        submitSearch () {
            if (this.filters.text != '') {
                this.hideSearchHistory()
                this.saveSearchHistory()

                this.matomoTrackEvent('Booking', 'Search', this.filters.text)
            }

            this.$emit('search', this.filters)
        },

        setDuration (filter) {
            this.filters.duration = filter

            if (this.filters.duration === null) {
                this.matomoTrackEvent('Booking', 'Filter', 'Alla längder')
            } else {
                this.matomoTrackEvent('Booking', 'Filter', filter + ' min')
            }

            this.submitSearch()
        },

        setProductArea (filter) {
            this.filters.product_area = filter
            this.filters.duration = null

            // if (this.filters.duration === null) {
            //     this.matomoTrackEvent('Booking', 'Filter', 'Alla längder')
            // } else {
            //     this.matomoTrackEvent('Booking', 'Filter', filter + ' min')
            // }

            this.submitSearch()
        },

        clearText () {
            this.filters.text = ''
            this.hideSearchHistory()
            this.submitSearch()
        },

        searchFromHistory (searchPhrase) {
            this.filters.text = searchPhrase
            this.submitSearch()
        },

        getSearchHistory () {
            // load search history from cookie
            const json_str = Cookies.get('searchHistory')
            if (json_str != undefined) {
                this.searchHistory = JSON.parse(json_str)
            } else {
                this.searchHistory = []
            }
        },

        saveSearchHistory () {
            // Save search string to array, if it is a text query search
            if (this.filters.text != '') {
                let arr = []
                const json_str = Cookies.get('searchHistory')
                if (json_str == undefined) {
                    arr.push(this.filters.text)
                } else {
                    arr = JSON.parse(json_str)
                    arr.unshift(this.filters.text)

                    // Remove all above 10 latest searches
                    if (arr.length > 10) {
                        arr.length = 10
                    }
                }
                const json_str2 = JSON.stringify(arr)
                Cookies.set('searchHistory', json_str2, { expires: 365 })
            }
        },

        clearSearchHistory () {
            Cookies.remove('searchHistory')
            this.getSearchHistory()
            this.hideSearchHistory()
        },

        showSearchHistory () {
            this.searchHistoryVisible = true
            this.getSearchHistory()
            jQuery('html').addClass('modal-open')
        },

        hideSearchHistory () {
            this.searchHistoryVisible = false
            jQuery('html').removeClass('modal-open')
        }
    }
}
</script>
<style type="text/css">

/* --- Fade transition --- */
.fade-enter-active, .fade-leave-active {
    transition: all 150ms ease;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
